import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement} from 'lit';
import stylesheet from './x-multi-basket-summary-container.scss?as=stylesheet';
import {classMap} from 'lit/directives/class-map.js';

export class MultiSystemBasketSummaryContainer extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			baseSubtotal: {
				attribute: 'base-subtotal',
				type: Number
			},
			deliveryDate: {
				attribute: 'delivery-date',
				type: String
			},
			formattedBaseSubtotal: {
				attribute: 'formatted-base-subtotal',
				type: String
			},
			formattedDeliveryDate: {
				attribute: 'formatted-delivery-date',
				type: String
			},
			formattedSubtotal: {
				attribute: 'formatted-subtotal',
				type: String
			},
			image: {
				type: String
			},
			open: {
				type: Boolean
			},
			quantity: {
				type: Number
			},
			subtotal: {
				type: Number
			}
		};
	}

	// eslint-disable-next-line max-lines-per-function
	constructor () {
		super();

		/**
		 * @type {number}
		 */
		this.baseSubtotal = 0;

		/**
		 * @type {string}
		 */
		this.deliveryDate = '';

		/**
		 * @type {string}
		 */
		this.formattedBaseSubtotal = '';

		/**
		 * @type {string}
		 */
		this.formattedDeliveryDate = '';

		/**
		 * @type {string}
		 */
		this.formattedSubtotal = '';

		/**
		 * @type {string}
		 */
		this.image = '';

		/**
		 * @type {boolean}
		 */
		this.open = false;

		/**
		 * @type {number}
		 */
		this.quantity = 0;

		/**
		 * @type {number}
		 */
		this.subtotal = 0;
	}

	// eslint-disable-next-line max-lines-per-function
	render () {
		const classes = {
			container: true,
			open: this.open
		};

		return html`
			<div class="${classMap(classes)}">
				<div class="heading">
					<div class="image">
						<img src="${this.image}" alt="" loading="lazy" />
					</div>

					<div class="details">
						<div class="details__header">Multi System</div>
						<div class="details__middle">
							<div class="quantity">
								<span class="label">QTY:</span>
								<span class="value">${this.quantity}</span>
							</div>
							<div class="delivery-date">
								<span class="label">Delivery Date:</span>
								<span class="value">${this.formattedDeliveryDate}</span>
							</div>
						</div>
						<div class="details__footer">
							<div class="details__footer-left">
								<button class="toggle" @click="${this.handleClick}">
									<span class="toggle__text">View Details</span>
									<span class="toggle__icon" aria-hidden="true"></span>
								</button>
							</div>
							<div class="details__footer-right">
								${this.formattedSubtotal}
							</div>
						</div>
					</div>
				</div>
				<div class="items">
					<slot></slot>
				</div>
			</div>
		`;
	}

	handleClick () {
		this.open = !this.open;
	}
};

defineCustomElement('x-multi-basket-summary-container', MultiSystemBasketSummaryContainer);
